var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInspectionForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11C4 7.13401 7.13401 4 11 4C12.7751 4 14.396 4.66076 15.6299 5.74976L16.995 4.28719C15.4033 2.86474 13.3026 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C13.125 20 15.078 19.2635 16.6177 18.0319L20.2928 21.7071C20.6834 22.0976 21.3165 22.0976 21.7071 21.7071C22.0976 21.3165 22.0976 20.6834 21.7071 20.2928L18.0319 16.6177C19.2635 15.078 20 13.125 20 11C20 10.6375 19.9786 10.28 19.9369 9.92868L17.9148 12.0952C17.3891 15.441 14.4934 18 11 18C7.13401 18 4 14.866 4 11Z",
    fill: "#192048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7912 9.29641L19.3474 7.62906C19.0817 6.97159 18.7405 6.35268 18.3346 5.78306L16.9335 7.28426C17.3184 7.89757 17.6108 8.57481 17.7912 9.29641Z",
    fill: "#192048"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1823 5.26894C20.5861 5.64578 20.6079 6.27857 20.2311 6.68232L13.2311 14.1823C13.046 14.3806 12.7884 14.4952 12.5172 14.4999C12.2461 14.5045 11.9847 14.3989 11.7929 14.2071L8.29289 10.7071C7.90237 10.3166 7.90237 9.68342 8.29289 9.29289C8.68342 8.90237 9.31658 8.90237 9.70711 9.29289L12.4752 12.061L18.7689 5.31768C19.1458 4.91393 19.7786 4.89211 20.1823 5.26894Z",
    fill: "#192048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectionForm);
export default __webpack_public_path__ + "static/media/inspectionForm.9fd046c9144a4540d9c7aeb97655b290.svg";
export { ForwardRef as ReactComponent };